<template>
  <div class="photos">
    <div class="row" v-if="(inphotos && inphotos.length) || (outphotos && outphotos.length)">
      <div :class="{
        'col-md-6': displaymode === 'center',
        'col-md-12': displaymode === 'left',
        hide: displaymode === 'right',
      }" v-if="displaymode === 'left' || displaymode === 'center'">
        <header>
          <h1 class="text-centered">Check-In Photos</h1>
        </header>
      </div>
      <div :class="{
        'col-md-6': displaymode === 'center',
        'col-md-12': displaymode === 'right',
        hide: displaymode === 'left',
      }" v-if="displaymode === 'right' || displaymode === 'center'">
        <header>
          <h1 class="text-centered">Check-Out Photos</h1>
        </header>
      </div>
    </div>
    <div v-else>
      <header>
        <h1>Photos</h1>
      </header>
    </div>

    <div class="row" v-if="(inphotos && inphotos.length) || (outphotos && outphotos.length)">
      <div class="scrollable" :class="{
        'col-md-6': displaymode === 'center',
        'col-md-12': displaymode === 'left',
        hide: displaymode === 'right',
      }" style="
          border-right: 5px solid #253746;
          display: flex;
          text-align: center;
        " id="ciscrollablediv">
        <!--viewer :images="inphotos" :options="invieweroptions" rebuild @inited="ciViewerInit"
          class="pane">
          <img v-for="(photo, index) in inphotos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
            :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
            class="gallery-image-size gallery-image-padding" :class="{
              highlight: cihighlight(photo),
            }" :id="`ciphoto-${photo.src}`" />
        </!--viewer-->

        <VViewer
          ref="inphotoviewer"
          :options="invieweroptions"
          :images="inphotos"
          rebuild
          class="pane"
          @inited="ciViewerInit"
        >
          <template #default="scope">
            <img v-for="(photo, index) in inphotos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
              :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
              class="gallery-image-size gallery-image-padding" :class="{
                highlight: cihighlight(photo),
              }" :id="`ciphoto-${photo.src}`" />
          </template>
        </VViewer>

      </div>
      <div class="scrollable" :class="{
        'col-md-6': displaymode === 'center',
        'col-md-12': displaymode === 'right',
        hide: displaymode === 'left',
      }" style="display: flex; text-align: center" id="coscrollablediv">
        <!--viewer v-if="outphotos && outphotos.length" :images="outphotos" :options="outvieweroptions" rebuild
          @inited="coViewerInit" class="pane">
          <img v-for="(photo, index) in outphotos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
            :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
            class="gallery-image-size gallery-image-padding" :class="{
              highlight: cohighlight(photo),
            }" :id="`cophoto-${photo.src}`" />
        </!--viewer-->
        <VViewer
          v-if="outphotos && outphotos.length"
          ref="outphotoviewer"
          :options="outvieweroptions"
          :images="outphotos"
          rebuild
          class="pane"
          @inited="coViewerInit"
        >
          <template #default="scope">
            <img v-for="(photo, index) in outphotos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
              :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
              class="gallery-image-size gallery-image-padding" :class="{
                highlight: cohighlight(photo),
              }" :id="`cophoto-${photo.src}`" />
          </template>
        </VViewer>
      </div>
    </div>

    <div v-else class="scrollable">
      <!--viewer v-if="photos && photos.length" :images="photos" :options="viewerOptions" rebuild @inited="viewerInit">
        <img v-for="(photo, index) in photos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
          :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
          class="gallery-image-size gallery-image-padding" />
      </!--viewer-->
      <VViewer
        v-if="photos && photos.length"
        ref="viewer"
        :options="viewerOptions"
        :images="photos"
        rebuild
        class="pane"
        @inited="viewerInit"
      >
        <template #default="scope">
          <img v-for="(photo, index) in photos" :key="index" :src="actProperty.resizedPhotoSrc(photo)"
            :data-src="actProperty.photoSrc(photo)" :alt="actProperty.formatDatetimeForDisplay(photo.createdAt)"
            class="gallery-image-size gallery-image-padding" />
        </template>
      </VViewer>
    </div>

    <!-- Status Bar (Bottom navbar) -->
    <nav class="navbar fixed-bottom navbar-dark bg-primary">
      <div class="container-fluid">
        <div class="btn-group" role="group" aria-label=""></div>

        <div id="status-bar-switches" style="margin-left: auto; margin-right: auto">
          <div class="btn-group" role="group" aria-label="Navigation">
            <button class="btn btn-outline-light" @click="moveDividerToLeft()" title="Only show Check In photographs">
              <i class="fa fa-arrow-left"></i><i class="fa fa-minus fa-rotate-90"></i>
            </button>

            <button class="btn btn-outline-light" @click="moveDividerToCenter()"
              title="Show Check In &amp; Check Out photographs">
              <i class="fa fa-angle-right"></i><i class="fa fa-minus fa-rotate-90"></i><i class="fa fa-angle-left"></i>
            </button>

            <button class="btn btn-outline-light" @click="moveDividerToRight()" title="Only show Check Out photographs">
              <i class="fa fa-minus fa-rotate-90"></i><i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, watch, inject, nextTick} from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import _flattenDeep from 'lodash/flattenDeep';
import _cloneDeepWith from 'lodash/cloneDeepWith';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import { useRoute, useRouter } from 'vue-router';
import {
  Photo,
  LinkedPhoto,
  Report,
  Alarm,
  Meter,
  Key,
  Item,
  OrderedItem,
  Type,
  Section,
  Room,
  Compliancesection,
  Complianceitem,
} from "@/models";
import { ReportsState } from "@/store/reports/types";
import Viewer from "v-viewer";
import { api as viewerApi } from 'v-viewer'
import { useToast } from "vue-toastification";
import VueViewer, { component as VViewer } from 'v-viewer';

const store = useStore();
const route = useRoute();
const router = useRouter();

const toasted = useToast();
const actProperty: any = inject('actProperty');

const reportsState = computed((): ReportsState => store.state.reports);

const report = computed(() => store.getters['reports/current']);
const gallerydisplaymode = computed(() => store.getters['reports/gallerydisplaymode']);

const getReport = (id: string): Promise<any> => {
  return store.dispatch('reports/getReportUnauthenticated', id);
};

const setPhotos = (photos: LinkedPhoto[]) => {
  store.commit('reports/setPhotos', photos);
};

const setInphotos = (photos: LinkedPhoto[]): void => {
  store.commit('reports/setInphotos', photos);
};

const setCurrentinphoto = (photo: LinkedPhoto): void => {
  store.commit('reports/setCurrentinphoto', photo);
};

const setOutphotos = (photos: LinkedPhoto[]): void => {
  store.commit('reports/setOutphotos', photos);
};

const setCurrentoutphoto = (photo: LinkedPhoto): void => {
  store.commit('reports/setCurrentoutphoto', photo);
};

const setGallerydisplaymode = (mode: string): void => {
  store.commit('reports/setGallerydisplaymode', mode);
};

const cihighlightedphotos = ref<Photo[]>([]);
const cohighlightedphotos = ref<Photo[]>([]);
const ordereditems = ref<OrderedItem[]>([]);
const inphotoviewer = ref(null);
const outphotoviewer = ref(null);
const viewer = ref(null);
const _civiewer = ref<Viewer>();
const _coviewer = ref<Viewer>();
const _viewer = ref<Viewer>();

const cihighlight = (photo: Photo) => {
  const index = cihighlightedphotos.value.findIndex(
    (p) =>
      p.src === photo.src ||
      p.src.endsWith(photo.src) ||
      photo.src.endsWith(p.src)
  );
  return index > -1;
};

const cohighlight = (photo: Photo) => {
  const index = cohighlightedphotos.value.findIndex(
    (p) =>
      p.src === photo.src ||
      p.src.endsWith(photo.src) ||
      photo.src.endsWith(p.src)
  );
  return index > -1;
};

const photos = computed(() => reportsState.value.photos);
const inphotos = computed(() => reportsState.value.inphotos);
const currentinphoto = computed(() => reportsState.value.currentinphoto);
const outphotos = computed(() => reportsState.value.outphotos);
const currentoutphoto = computed(() => reportsState.value.currentoutphoto);

const viewerOptions = computed(() => {
  return {
    inline: false,
    toolbar: {
      zoomIn: "large",
      zoomOut: "large",
      prev: "large",
      next: "large",
      download: () => {
        downloadPhoto();
      },
    },
    url: "data-src",
    view: (event: any) => {
      console.log(event.detail.index);
    },
    viewed: (event: any) => {
      console.log(event.detail.index);
    },
    className: "",
  }
});

const invieweroptions = computed(() => {
  let options = _cloneDeepWith(viewerOptions.value);
  options.view = (event: any) => {
    let clickedphoto: LinkedPhoto = inphotos.value[event.detail.index];
    if (
      clickedphoto &&
      clickedphoto.linkedphotos &&
      clickedphoto.linkedphotos.length
    ) {
      setCurrentinphoto(clickedphoto);
      cohighlightedphotos.value = clickedphoto.linkedphotos;
      const firstlinkedphoto = clickedphoto.linkedphotos[0];
      const photoEl: HTMLElement | null = document.getElementById(
        `cophoto-${firstlinkedphoto.src}`
      );
      const topPos = photoEl?.offsetTop;
      const scrollableDiv = document.getElementById("coscrollablediv");
      if (scrollableDiv && topPos) scrollableDiv.scrollTop = topPos;
    } else {
      cohighlightedphotos.value = [];
    }
  };
  options.toolbar.download = () => {
    downloadPhoto(_civiewer.value);
  };
  if (displaymode.value === "center") options.className = "center-civiewer";
  else options.className = "only-civiewer";
  return options;
});

const outvieweroptions = computed(() => {
  let options = _cloneDeepWith(viewerOptions.value);
  options.view = (event: any) => {
    let clickedphoto: LinkedPhoto = outphotos.value[event.detail.index];
    if (
      clickedphoto &&
      clickedphoto.linkedphotos &&
      clickedphoto.linkedphotos.length
    ) {
      setCurrentoutphoto(clickedphoto);
      if (
        !_.isEmpty(
          _.xorWith(
            cihighlightedphotos.value,
            clickedphoto.linkedphotos,
            _.isEqual
          )
        )
      ) {
        // Item has changed
        // Hide CO photo
        _civiewer.value.hide();
      }
      cihighlightedphotos.value = clickedphoto.linkedphotos;
      const firstlinkedphoto = clickedphoto.linkedphotos[0];
      const photoEl: HTMLElement | null = document.getElementById(
        `ciphoto-${firstlinkedphoto.src}`
      );
      const topPos = photoEl?.offsetTop;
      const scrollableDiv = document.getElementById("ciscrollablediv");
      if (scrollableDiv && topPos) scrollableDiv.scrollTop = topPos;
    } else {
      cihighlightedphotos.value = [];
    }
  };
  options.toolbar.download = () => {
    downloadPhoto(_coviewer.value);
  };
  if (displaymode.value === "center") options.className = "center-coviewer";
  else options.className = "only-coviewer";
  return options;
});


const displaymode = computed({
  get: () => gallerydisplaymode.value,
  set: (mode: string) => {
    setGallerydisplaymode(mode);
  }
});

const civiewer = computed({
  get: () => _civiewer.value,
  set: (viewer: Viewer) => {
    _civiewer.value = viewer;
  }
});

const coviewer = computed({
  get: () => _coviewer.value,
  set: (viewer: Viewer) => {
    _coviewer.value = viewer;
  }
});

const baseviewer = computed({
  get: () => _viewer.value,
  set: (viewer: Viewer) => {
    _viewer.value = viewer;
  }
});

const ciViewerInit = (viewer: Viewer) => {
  civiewer.value = viewer;
  initViewer(viewer, inphotos.value, "ci");
}

const coViewerInit = (viewer: Viewer) => {
  coviewer.value = viewer;
  initViewer(viewer, outphotos.value, "co");
}

const viewerInit = (v: Viewer) => {
  baseviewer.value = v;
  initViewer(v, photos.value, "default");
}

const isCheckout = () => {
  return report.value && report.value.type === "checkout";
}

const initViewer = (viewer: Viewer, photosarray: LinkedPhoto[], cico: string) => {
  const { src, itemref } = route.params;
  if (src && src != "-") {
    // The src is base64 encoded, so let's decode it
    const base64DecodedSrc = new Buffer((src as string), "base64").toString("ascii");

    // Locate the Photo by matching on Photo.src
    const index = photosarray.findIndex(
      (x: LinkedPhoto) => x.src === base64DecodedSrc
    );

    viewphoto(viewer, index, cico);
  } else if (
    itemref &&
    itemref != "-" &&
    isCheckout() &&
    cico == 'co'
  ) {
    if (ordereditems.value && ordereditems.value.length) {
      let selecteditem = ordereditems.value.find(
        (item: OrderedItem) => item.order === parseInt(itemref as string)
      );
      if (selecteditem) {
        const cophotos = _get(selecteditem, `condition.out.photos`, []);
        if (cophotos && cophotos.length) {
          // Locate the Photo by matching on Photo.src
          const index = outphotos.value.findIndex(
            (x: LinkedPhoto) =>
              cophotos[0].src.endsWith(x.src) ||
              x.src.endsWith(cophotos[0].src)
          );
          if (index > -1) {
            const siblingphotos = outphotos.value.filter(
            (x: LinkedPhoto) => {
              const i = cophotos.findIndex((p) => x.src.endsWith(p.src) ||
              p.src.endsWith(x.src));
              return i >= 0;
            });
            cohighlightedphotos.value = siblingphotos;
            cihighlightedphotos.value = siblingphotos[0].linkedphotos;
            setTimeout(() => {
              if(cohighlightedphotos.value?.length > 0) {
                // Scroll CO side to the highlighted photo
                const coelement = document.getElementById(`cophoto-${cohighlightedphotos.value[0].src}`);
                if (coelement) {
                  coelement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
              }
              setTimeout(() => {
                // Scroll CI side to the highlighted photo
                if(cihighlightedphotos.value?.length > 0) {
                    const cielement = document.getElementById(`ciphoto-${cihighlightedphotos.value[0].src}`);
                    if (cielement) {
                      cielement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    }
                  }
              }, 1000);
            }, 1000);
            
            //viewphoto(viewer, index, cico);
          }
        }
      }
    }
  }
}

const viewphoto = (viewer: Viewer, index: number, cico: string) => {
  if (index > -1) {
    if (
      cico === "ci" &&
      (displaymode.value === "left" || displaymode.value === "center")
    ) {
      viewer.view(index);
    } else if (
      cico === "co" &&
      (displaymode.value === "right" || displaymode.value === "center")
    ) {
      viewer.view(index);
    } else if (cico === "default") {
      viewer.view(index);
    }
  }
}

const downloadPhoto = (v?: Viewer) => {
  try {
    // Get current image title
    let photoViewer: any = v ? v : baseviewer.value;
    let imageTitle = photoViewer.title.innerHTML;
    // Only show the title text after the /
    let filteredTitle = imageTitle.lastIndexOf("/");

    let startOfTitle = imageTitle.substring(filteredTitle + 1);
    let end = startOfTitle.substr(0, startOfTitle.lastIndexOf("."));
    let newImageTitle = end.replace(/\d+-/g, "");

    let localviewer: any = v;
    if (!v) {
      localviewer = photoViewer;
    }

    let url = localviewer.image.src;
    let label = newImageTitle;

    // Download image as a jpeg
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "image/jpeg" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = label;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);

    toasted.success(
      "Photo downloaded. Please check your downloads folder."
    );
  } catch (err) {
    console.error(err);
    toasted.error("Photo download failed. Please try again.");
  }
};

const init = async () => {
  await getReport(route.params.id as string).then(async (report: Report) => {
    if (report === undefined) {
      router.push({ name: "reportnotfound" });
    } else {
      ordereditems.value = getReportItems();
      const generalphotos: LinkedPhoto[] = getGeneralPhotos(report);

      if (report.type === "checkout") {
        const inkeyphotos: LinkedPhoto[] = getKeyPhotos("in");
        const outkeyphotos: LinkedPhoto[] = getKeyPhotos("out");
        const inroomphotos: LinkedPhoto[] = getRoomPhotos("in");
        const outroomphotos: LinkedPhoto[] = getRoomPhotos("out");
        setPhotos([...inkeyphotos, ...inroomphotos]);
        setInphotos([...inkeyphotos, ...inroomphotos]);
        setOutphotos([
          ...generalphotos,
          ...outkeyphotos,
          ...outroomphotos,
        ]);
      } else {
        const inkeyphotos: LinkedPhoto[] = getKeyPhotos("in");
        const compliancephotos: LinkedPhoto[] = getCompliancePhotos();
        const inroomphotos: LinkedPhoto[] = getRoomPhotos("in");
        setPhotos([
          ...generalphotos,
          ...compliancephotos,
          ...inkeyphotos,
          ...inroomphotos,
        ]);
      }

      if (route.params.type === "in") displaymode.value = "left";
      else if (route.params.type === "out") displaymode.value = "right";
      else displaymode.value = "center";
    }
  });
};

const getGeneralPhotos = (report: Report): LinkedPhoto[] => {
  // PDF Section: General Notes
  const propertyDetailsPhotos = _flattenDeep([
    ..._get(report, "propertyDetails.locationPhotos"),
    ..._get(report, "propertyDetails.cleaningReceiptPhotos"),
  ]).filter(Boolean);

  // PDF Section: Meter Readings
  const meters: Meter[] = _get(report, "meters", []);
  const meterPhotos = _flattenDeep(
    meters.map((meter: any) => meter.photos)
  ).filter(Boolean);

  // PDF Section: Safety Alarms
  const alarms: Alarm[] = _get(report, "alarms", []);
  const alarmPhotos = _flattenDeep(
    alarms.map((alarm: any) => alarm.photos)
  ).filter(Boolean);

  // PDF Section: Comments
  const commentPhotos = _flattenDeep([
    ..._get(report, "comments.tenantPhotos", ""),
    ..._get(report, "comments.clientPhotos", ""),
  ]).filter(Boolean);

  // Return one big array
  const allphotos: Photo[] = [
    ...propertyDetailsPhotos,
    ...meterPhotos,
    ...alarmPhotos,
    ...commentPhotos,
  ];

  return allphotos.map((photo: Photo) => new LinkedPhoto(photo));
}

const getKeyPhotos = (type: string): LinkedPhoto[] => {
  const oppositetype = type === "in" ? "out" : "in";
  const keys: Key[] = _get(report.value, "keys", []);
  const keyPhotos: LinkedPhoto[] = _flattenDeep(
    keys.map((key) => {
      const typephotos = _get(key, `photos.${type}`, []);
      const oppositetypephotos: any[] = _get(key, `photos.${oppositetype}`, []);
      if (typephotos && typephotos.length) {
        return typephotos.map((photo: Photo) => {
          return prepareLinkedphoto(photo, oppositetypephotos);
        });
      }
      return typephotos;
    })
  ).filter(Boolean);
  return keyPhotos;
}

const getCompliancePhotos = (): LinkedPhoto[] => {
  const compliancesections: Compliancesection[] = _get(
    report.value,
    "compliancesections",
    []
  );
  const compliancephotos: LinkedPhoto[] = _flattenDeep(
    compliancesections.map((compliancesection: Compliancesection) => {
      const complianceitems: Complianceitem[] =
        compliancesection.complianceitems;
      return complianceitems.map((complianceitem: Complianceitem) => {
        if (complianceitem.photos && complianceitem.photos.length) {
          return complianceitem.photos.map(
            (photo: Photo) => new LinkedPhoto(photo)
          );
        }
        return complianceitem.photos;
      });
    })
  );
  return compliancephotos;
}

const getRoomPhotos = (type: string): LinkedPhoto[] => {
  const oppositetype = type === "in" ? "out" : "in";
  const rooms: Room[] = report.value.rooms;
  const roomsPhotos: LinkedPhoto[] = _flattenDeep(
    rooms.map((room: Room) => {
      const sections: Section[] = room.sections;
      return sections.map((section: Section) => {
        const types: Type[] = section.types;
        return types.map((itemType: Type) => {
          const items: Item[] = itemType.items;
          return items.map((item: Item) => {
            const typephotos = _get(item, `condition.${type}.photos`, []);
            const oppositetypephotos = _get(
              item,
              `condition.${oppositetype}.photos`,
              []
            );
            if (typephotos && typephotos.length) {
              return typephotos.map((photo: Photo) => {
                return prepareLinkedphoto(photo, oppositetypephotos);
              });
            }
            return typephotos;
          });
        });
      });
    })
  ).filter(Boolean);
  return roomsPhotos;
}

const prepareLinkedphoto = (photo: Photo, photos: Photo[]): LinkedPhoto => {
  const linkedPhoto = new LinkedPhoto(photo);
  if (photos && photos.length) {
    photos.forEach((photo: Photo) => {
      linkedPhoto.addLinkedphoto(photo);
    });
  }
  return linkedPhoto;
}

const getReportItems = (): OrderedItem[] => {
  let items: OrderedItem[] = [];
  if (report.value && report.value.rooms) {
    report.value.rooms.forEach((room, roomindex) => {
      if (room.sections) {
        room.sections.forEach((section, sectionindex) => {
          if (section.types) {
            section.types.forEach((type, typeindex) => {
              if (type.items) {
                type.items.forEach((item, itemindex) => {
                  let orderedItem = new OrderedItem(item);
                  orderedItem.roomname = room.name;
                  orderedItem.roomindex = roomindex;
                  orderedItem.section = section.name;
                  orderedItem.sectionindex = sectionindex;
                  orderedItem.type = type.name;
                  orderedItem.typeindex = typeindex;
                  orderedItem.item = item;
                  orderedItem.itemindex = itemindex;
                  items.push(orderedItem);
                });
              }
            });
          }
        });
      }
    });
  }

  const orderedlist = items.map((item, order) => {
    item.order = order + 1;
    return item;
  });

  return orderedlist;
}

const moveDividerToLeft = () => {
  displaymode.value = "left";
}

const moveDividerToCenter = () => {
  displaymode.value = "center";
}

const moveDividerToRight = () => {
  displaymode.value = "right";
}

watch(() => route.params.id, (val, oldVal) => {
  if (route.params.id) {
    init();
  }
});

onMounted(() => {
  displaymode.value = "center";
  init();
});

</script>


<style lang="scss">
.scrollable {
  flex-grow: 1;
  overflow-y: auto !important;
  height: 80vh;
}

.highlight {
  background-color: #ded140;
}

.text-centered {
  text-align: center;
}

img {
  cursor: pointer;
}

.gallery-image-padding {
  padding: 0.5em;
}

.gallery-image-size {
  width: 130px;
}

.viewer-download::before {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAAAUCAYAAABWOyJDAAAFlElEQVR4Xu2aW8ilUxjHf3+nHAujNHLlQkQu5BTmApmoMdJcyBQ5JiRDjUmYU+QUkiRnRSShmBIT4zRphlwoKcmVTA5JkqTRX8+09uedd/a391rv3rv59metu+9713r2s/7rWb/3Wc96RW1VgapAVWBCCmhCdqvZqkBVoCpABUwNgqpAVWBiClTATEzaargqUBWogKkxUBUYUQHb64B/JK0f0dS8G54FGNsfx8wlLdrdCiRfzgQ+6efPsOeD/Ld9AXAzcHLq9xnwkKQNttdIikDq1GwfD7wJ/Czp1FIjtjcBayV9WDq2X3/bsfafAgcBF0r6dlS7tvcBHpV07ai2ZvH5CeBGSX9Pwn4Xmwkuq9PYiJFiyNh277cl7bQnBz0b5m+M7Wev/b9hdtrPez7l2MkFzA4BcgyWOlvavwGQvv4Mez7b79m+C7h9lucB2EVd5287gBhwOQR4R9J5HebdC8IPxgUa25uB04EfgSWSPi/1q9ff9uHAa8AZwLJk8ytJv3W1GeNsHwwcB/Tsh8/LJIXPu7W14NLzpRgy/UDQb1OXxl8FTMfwaBO0nWGVEDYF8RLgLSDejCuBFyO2gUuBB4G9ugI2ZUWvAPsBbwDLJf1VOvXmmyyNHRk0tg8EXgUCeH+kjftuB99OSnM7sjX2H+A94DZJX5TYtX0icA9wDrBna+z3wEUlQLS9erbswnZkhmtL/Gv2LY23LvDIgVAD9hPJiNr2c4A3dRlMAsJOGVUCTMw3MoV46xVlXLbfB84CVkh6pCHkmsgWen/nCNoKvMuBpxKgngSulxSbrrj1AUzPxkigsb038EyCaQD2CkkvlThoO8ZfOWBMAHWxpB1H7WHNdhzFA3T7Duj7rKSrhtlK8RBHmHWzrV/SNp53gkxpvOX4PJf7lMy3L2Cax4wBE+1bA+nXfwL2BgKkRIAUgL+nWsQCSb+OY3Ftr0pv4NB4vaSAVec2ADBN0ER6/lHpj6R6zL3ArSlzWykpMrfsZvsW4P6UbdwHHAoE8I9NRrZIOi3HoO0twCmp79dRbwNiXULTAPSqXP8icwm45PxuglAxZErjLdOXOdutZL6jAGZzL2MYpkQmYErsTQNgVkSBOEpXQGy4OCbMpK7DNGs/zwRMvIUjoylqCTBxHIkNHD4WAyaB+lzgZUmHpb9j7tcBjwHbJUW2NLTZ3p5AdQPweE83278Al0jaONRI6mA7iq53ZvaPo1IujGZMlmy4TD/mdLeS+c6nI9LMLVeJAGkj9D0ipWfxVg9AbJJ0dsnK214OPAfE7crzwDWSYvMUtyFHpE5gSfOLTf80cFmqQV0t6YViB//b0EdJ+q453nbUXxZKWphj1/Y2YJukqMM0N/IutjPtBTSiBjPbCzWg2gkuScOiI3mOz3O5T8n+mk+AGaUGE9fTccvTK/L2NlgUeR9IgFgqKQrBRc324nS7EgXVDcDFkv4sMtKoKzXGRabSGSxpYxyQirznj1LkHTaXdMW+VVJkSEOb7QB63NrFDddYWtz4zHZMHcMnCCMBJqeAm9OnJ9Skrr3b9nNqkvMCMO0ILCFsQ7RB19R3S7qja6Tbju9q3gYWdMmEmm9JYKSibisjiNpGXCv/lK6p47ufsTbbRwNROI+r5Syw2t4/QfkmSd+M1aExGgswNS8BkunielsOPHL69NsH4/wOpst8cwET1f+ZDGGMa9TJVPvWqI+wnfy1vTRukhoFxq3Aw10ylz4+HQO8HsXK3NpVCwZz/kO7lr8RW0cAJwAbS4+GtuPTgKjpfAn8MEr9qlOQZQ5qbbpiuLReHrt82zXXPrQrnW8WYDK1rt2qAv9LBdKm22PUm8JpEa9kvhUw07Kq1c+qwBQqUAEzhYtWXa4KTIsCFTDTslLVz6rAFCpQATOFi1ZdrgpMiwL/Arcs9zPYheL+AAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-size: 280px;
  color: transparent;
  display: block;
  font-size: 0;
  height: 20px;
  line-height: 0;
  width: 20px;
}

.viewer-download::before {
  background-position: -260px 0;
  content: "Download";
}

.viewer-container {
  overflow: hidden;
  position: absolute;
}

.only-civiewer {
  margin-top: 59px;
  margin-bottom: 50px;
  //top: 59px;
}

.only-coviewer {
  margin-top: 59px;
  margin-bottom: 50px;
  //top: 59px;
}

.center-civiewer {
  margin-top: 59px;
  margin-bottom: 50px;
  right: 50% !important;
  //top: 59px;
}

.center-coviewer {
  margin-top: 59px;
  margin-bottom: 50px;
  left: 50% !important;
  //top: 59px;
}

.viewer-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.center-civiewer>.viewer-canvas>img {
  //width: auto !important;
  //height: 60% !important;
  margin-left: auto !important;
  margin-top: 10% !important;
  margin-bottom: 10% !important;
  transform: none !important;
  position: relative !important;
}

.center-coviewer>.viewer-canvas>img {
  //width: auto !important;
  //height: 60% !important;
  margin-left: auto !important;
  margin-top: 10% !important;
  margin-bottom: 10% !important;
  transform: none !important;
  position: relative !important;
}

.rotate90 {
  transform: rotate(90deg);
}

.hide {
  display: none !important;
}

#app {
  padding-bottom: 0em !important;
}

#status-bar-buttons,
#status-bar-switches,
#status-bar-actions {

  .btn-group,
  .custom-switch {
    display: inline-block;
    margin: 0 0.5rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.status-bar-separator {
  color: #f8f9fa;
}

#status-bar-switches {
  margin-left: 2rem;
}

#status-bar-actions {
  width: 22rem;
  text-align: right;

  span {
    margin-right: 0.25rem;
  }
}
</style>
